export const EMBED_CHANNEL = 'ssm.embed';

export const EMBED_VERSION = 1;

export const MESSAGE_TYPES = {
    ACTION: 'action',
    CLOSE: 'close',
    INIT: 'init',
    NOTIFY: 'notify',
    READY: 'ready',
    REQUEST_CONTEXT_REFRESH: 'requestContextRefresh',
    RESIZE: 'resize',
    STATE: 'state',
};

const CHILD_TO_PARENT_TYPES = new Set([
    MESSAGE_TYPES.CLOSE,
    MESSAGE_TYPES.NOTIFY,
    MESSAGE_TYPES.READY,
    MESSAGE_TYPES.REQUEST_CONTEXT_REFRESH,
    MESSAGE_TYPES.RESIZE,
    MESSAGE_TYPES.STATE,
]);

export const DEFAULT_IFRAME_TITLE = 'External embed';

export const DEFAULT_IFRAME_MIN_HEIGHT_PX = 320;
// `allow-same-origin` keeps postMessage origin validation usable. Do not embed untrusted
// same-origin content with this default, because scripts could relax their own sandbox.
export const DEFAULT_IFRAME_SANDBOX = 'allow-scripts allow-forms allow-same-origin';
export const RESIZE_HEIGHT_MAX_PX = 10000;
export const RESIZE_THROTTLE_MS = 100;

export const createEmbedEnvelope = (type, payload = {}) => ({
    channel: EMBED_CHANNEL,
    payload,
    type,
    version: EMBED_VERSION,
});

export const isValidEmbedEnvelope = (data) => {
    return (
        data !== null &&
        typeof data === 'object' &&
        data.channel === EMBED_CHANNEL &&
        data.version === EMBED_VERSION &&
        typeof data.type === 'string'
    );
};

export const isChildToParentMessage = (data) => {
    if (!isValidEmbedEnvelope(data)) return false;
    return CHILD_TO_PARENT_TYPES.has(data.type);
};

export const getAllowedOriginFromSrc = (iframeSrc) => {
    try {
        return new URL(iframeSrc).origin;
    } catch {
        return null;
    }
};

export const normalizeResizeHeight = (value) => {
    const height = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(height) || height <= 0) return null;
    return Math.min(Math.floor(height), RESIZE_HEIGHT_MAX_PX);
};

export const throttleResize = (callback, waitMs = RESIZE_THROTTLE_MS) => {
    let lastRun = 0;
    let trailingTimer = null;
    let trailingHeight = null;

    return (height) => {
        const now = Date.now();
        const elapsed = now - lastRun;

        const invoke = (nextHeight) => {
            lastRun = Date.now();
            callback(nextHeight);
        };

        if (elapsed >= waitMs) {
            if (trailingTimer) {
                clearTimeout(trailingTimer);
                trailingTimer = null;
            }
            invoke(height);
            return;
        }

        trailingHeight = height;

        if (!trailingTimer) {
            trailingTimer = setTimeout(() => {
                trailingTimer = null;
                invoke(trailingHeight);
            }, waitMs - elapsed);
        }
    };
};
